import styled from 'styled-components';

import { DIRECTION, DIRECTION_LEFT } from 'webclient.constants';
import { rem } from 'approot/shared/style';
import { grey1, purple7 } from 'approot/shared/styles/colours.style';
import { standardFocusState } from 'approot/shared/styles/borders.style';

type ReorderStyledProps = {
  $direction?: DIRECTION;
  $disabled?: boolean;
};

export const ReorderStyled = styled.button<ReorderStyledProps>`
  background: ${purple7};
  border: 0;
  border-radius: 50%;
  color: ${grey1};
  width: ${rem(36)};
  height: ${rem(36)};
  display: flex;
  align-items: center;
  justify-content: center;

  transform: rotate(
    ${props => (props.$direction === DIRECTION_LEFT ? '90deg' : '-90deg')}
  );

  svg path {
    fill: ${grey1};
  }

  &:hover {
    cursor: pointer;
  }

  ${props =>
    props.$disabled &&
    `
    opacity: 0.5;
    cursor: not-allowed;

    &:hover {
      cursor: not-allowed;
    }
  `}

  ${standardFocusState}
`;
